import { LogAPI } from './api/index.ts';

export const log = LogAPI.getInstance();
